import { makeStyles } from "@mui/styles";

export default makeStyles((theme) => ({
  formGroup: {
    position: "relative",
    marginBottom: "20px",
    "& .MuiFormControl-root": {
      width: "100%"
    }
  },

  btnPrimary: {
    background: theme?.palette?.primary2TextColor?.main,
    borderRadius: "10px",
    padding: "6px 20px",
    color: `${theme?.palette?.secondaryText?.[700]} !important`,
    fontSize: "14px",
    fontWeight: "600",
    height: "45px",
    textTransform: "capitalize",
    width: "100%",
    "&:hover": {
      background: theme?.palette?.primaryBG?.[450],
      color: `${theme?.palette?.primaryText?.[100]} !important`
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "12px"
    }
  },
  loginLogo: {
    textAlign: "center",
    margin: "20px 0",
    "& img,svg": {
      width: "100px"
    }
  },
  loginContent: {
    textAlign: "center",
    margin: "20px 0",
    "& .MuiTypography-h5": {
      fontWeight: "bold",
      textTransform: "uppercase"
    }
  },
  loginFormWrap: {
    padding: "20px 40px",
    "& .MuiInputBase-input": {
      height: "20px",
      padding: "10px",
      "&:hover": {
        "& .MuiOutlinedInput-notchedOutline": {
          borderColor: theme?.palette?.primary2TextColor?.main
        }
      }
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderRadius: "10px"
    },
    "& .MuiFormLabel-root": {
      top: "-5px",
      fontSize: "12px",
      color: "rgba(255, 255, 255, 0.3)"
    },
    "& fieldset": {
      borderColor: `${theme?.palette?.textFieldBorder} !important`
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: `${theme?.palette?.textFieldBorder} !important`
    }
  },
  showLink: {
    position: "absolute",
    right: "10px",
    top: "13px",
    fontSize: "10px",
    textDecoration: "none",
    color: "rgb(237 215 215)"
  },
  authBtnWrap: {
    margin: "30px 0",
    "& .MuiTypography-root": {
      textAlign: "center",
      fontWeight: "600"
    }
  },
  forgotLink: {
    margin: "10px 0",
    textAlign: "center",
    "& .MuiButton-root": {
      margin: "0",
      padding: "0",
      textDecoration: "none",
      color: theme?.palette?.primary2TextColor?.main,
      fontSize: "1rem",
      textTransform: "none"
    },
    "& .MuiButton-root:hover": {
      background: "transparent"
    }
  }
}));
